import {
  Col,
  DatePicker,
  Form,
  Input,
  message,
  Modal,
  Popconfirm,
  Popover,
  Row,
  Select,
  Spin,
  Table,
} from "antd";
import COLORS from "common/Colors";
import {
  APPROVAL_FILTER_TYPES,
  MONTH_LIST,
  STATUS_CODE,
} from "common/Constants";
import dayjs from "dayjs";
import React, { useEffect, useMemo, useRef, useState } from "react";
import styled from "styled-components";
import { dateInDetail, getKenyanDateTime } from "utils/Date";
import localeData from "dayjs/plugin/localeData";
import weekday from "dayjs/plugin/weekday";
import advancedFormat from "dayjs/plugin/advancedFormat";
import {
  DeleteOutlineOutlined,
  EditOutlined,
  Info,
  SearchOutlined,
} from "@mui/icons-material";
import { ButtonFilled } from "reusableComponent/UIButtons";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllDepartmentList,
  getLoadNewList,
  getUserInfo,
  getUserList,
} from "redux/selectors";
import { CALL_API } from "common/API";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import { DropdownCheckBox } from "atoms/UIDropdown/Dropdown";
import { setLoadNewList } from "redux/actions";
import SuccessDeclinePopup from "reusableComponent/Popup/SuccessDeclinePopup";
import { ReactComponent as User } from "../../../assets/User_02.svg";

dayjs.extend(isSameOrAfter);

dayjs.extend(localeData);
dayjs.extend(weekday);
dayjs.extend(advancedFormat);

const PRIMARY = "#2d53da";

const MyTeamPerformanceWrap = styled.div`
  .ant-input-affix-wrapper,
  .ant-input,
  .ant-picker,
  .ant-btn {
    border-radius: 24px;
  }

  .ant-select .ant-select-selector {
    border-radius: 24px;
  }
  .ant-input::placeholder {
    color: #000;
  }

  .ant-input:hover::placeholder {
    color: "#2d53da";
  }
  .ant-input::placeholder,
  .ant-picker-input > input::placeholder {
    color: #9ca3af !important;
  }

  .ant-select-selection-placeholder {
    color: #9ca3af !important;
  }
`;

const StyledTable = styled(Table)`
  .ant-table {
    border: 1px solid #ccc;
    border-radius: 12px;
    overflow: hidden;
  }

  .ant-table-container {
    border-radius: 12px;
  }

  .ant-table-content {
    overflow-x: auto;
  }

  table {
    width: 100%;
    min-width: 900px;
  }

  .ant-table-cell {
    padding: 16px;
    white-space: wrap;
    overflow: hidden;
  }

  .ant-table-thead .ant-table-cell {
    font-weight: 600;
    color: ${COLORS.SECONDARY_BLACK};
  }

  .reason-column {
    min-width: 280px;
    white-space: normal;
  }

  .non-white {
    background: #f9f9f9;
  }

  @media (max-width: 768px) {
    .ant-table-cell {
      padding: 10px;
      font-size: 12px;
    }
  }
`;

const ActionWrapper = styled.div`
  opacity: 0;
  transition: opacity 0.3s ease;
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  color: #2d53da;

  /* Show on row hover */
  .ant-table-row:hover & {
    opacity: 1;
  }
`;

const MyTeamPerformance = ({ setKpiDataList, setIsViewKpi, Menulist }) => {
  const dispatch = useDispatch();
  const userList = useSelector(getUserList);
  const userInfo = useSelector(getUserInfo);
  const loadNewList = useSelector(getLoadNewList);
  console.log("loadNewList", loadNewList);
  const departmentList = useSelector(getAllDepartmentList);
  const [form] = Form.useForm();
  const containerRef = useRef(null);
  const history = useHistory();
  const pageTitleRef = useRef(null);
  const { t } = useTranslation();
  const [myTeamData, setMyTeamData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [popupOpen, setPopupOpen] = useState(false);
  const [loadDataLoading, setLoadDataLoading] = useState(false);
  const activeUser = userList
    ?.filter(
      (item) =>
        item?.statusid === "1" && item?.reportingmanager === userInfo?.userid
    )
    ?.map((user) => {
      return {
        fullname: user?.fullname ?? "",
        hireddate: user?.hireddate
          ? dayjs(user?.hireddate)?.format("DD-MM-YYYY")
          : "",
        appraiseeuserid: user?.userid ?? "",
        appraiseruserid: user?.reportingmanager ?? "",
        basedepartmentid: user?.basedepartmentid ?? "",
        departmentname:
          departmentList?.find(
            (d) => d?.department_id === user?.basedepartmentid
          )?.department_name ?? "",
      };
    });
  console.log("activeUser", activeUser);
  const [scrollY, setScrollY] = useState(120);

  const handleDelete = async (record) => {
    setDeleteLoading(true);
    try {
      const { code } = await CALL_API(`performance/KPI/${record.id}`, "delete");
      if (code === STATUS_CODE.SUCCESS) {
        setPopupOpen(true);
        setTimeout(() => {
          fetchData();
          setPopupOpen(false);
        }, 2000);
      } else {
        message.error("Failed to delete");
      }
    } catch (error) {
      console.error("Delete error:", error);
      message.error("Failed to delete");
    } finally {
      setDeleteLoading(false);
    }
  };

  const findData = useMemo(() => {
    if (!userList?.length) return [];

    const filterUserList = userList.filter(
      (user) =>
        user?.statusid === "1" && user?.reportingmanager === userInfo?.userid
    );

    const reduceList = filterUserList.reduce((acc, item) => {
      const matchedContract =
        myTeamData?.filter((val) => val?.appraiseeuserid === item?.userid) ||
        [];

      if (matchedContract.length > 0) {
        matchedContract.forEach((match) => {
          acc.push({
            fullname: item?.fullname ?? "",
            hireddate: item?.hireddate
              ? dayjs(item.hireddate).format("DD-MM-YYYY")
              : "",
            appraiseeuserid: item?.userid ?? "",
            appraiseruserid: item?.reportingmanager ?? "",
            basedepartmentid: item?.basedepartmentid ?? "",
            departmentname:
              departmentList?.find(
                (d) => d?.department_id === item?.basedepartmentid
              )?.department_name ?? "",
            title: match?.title ?? "",
            type: match?.type ?? "",
            attendstartdate: match?.attendstartdate
              ? dayjs(match.attendstartdate).format("YYYY-MM-DD")
              : "",
            kpirole: match?.kpirole ?? [],
            templateid: match?.templateid ?? "",
            id: match?.id ?? "",
            createdat: match?.createdat
              ? dayjs(match.createdat).format("YYYY-MM-DD")
              : "",
            templatename: match?.templatename ?? "",
            kpistatus: match?.kpistatus ?? "",
            appraiserintroductorysection:
              match?.appraiserintroductorysection ?? [],
            appraisermainquestionnairesection:
              match?.appraisermainquestionnairesection ?? [],
            appraiserremarkssection: match?.appraiserremarkssection ?? [],
            attendedon: match?.attendedon ?? null,
            reviewedon: match?.reviewedon ?? null,
          });
        });
      } else {
        acc.push({
          fullname: item?.fullname ?? "",
          hireddate: item?.hireddate
            ? dayjs(item.hireddate).format("DD-MM-YYYY")
            : "",
          appraiseeuserid: item?.userid ?? "",
          appraiseruserid: item?.reportingmanager ?? "",
          basedepartmentid: item?.basedepartmentid ?? "",
          departmentname:
            departmentList?.find(
              (d) => d?.department_id === item?.basedepartmentid
            )?.department_name ?? "",
          title: "",
          type: "",
          attendstartdate: "",
          kpirole: [],
          templateid: "",
          templatename: "",
          kpistatus: "",
          appraiserintroductorysection: [],
          appraisermainquestionnairesection: [],
          appraiserremarkssection: [],
          attendedon: null,
          reviewedon: null,
        });
      }

      return acc;
    }, []);

    const usersWithKpi = new Set(
      reduceList.filter((item) => item?.id).map((item) => item?.appraiseeuserid)
    );

    const filteredLoadNewList = (
      Array.isArray(loadNewList) ? loadNewList : []
    ).filter((item) => !usersWithKpi.has(item?.appraiseeuserid));

    const merged = [...loadNewList, ...reduceList];

    return merged;
  }, [userList, myTeamData, loadNewList, departmentList, userInfo]);

  const loadNewData = () => {
    console.log("working12");
    if (!userList) return [];
    setLoadDataLoading(true);

    const filterUserList = userList?.filter(
      (user) =>
        user?.statusid === "1" && user?.reportingmanager === userInfo?.userid
    );

    console.log("working123", filterUserList);

    const reduceList = filterUserList.reduce((acc, item) => {
      const userKpis = myTeamData?.filter(
        (val) => val?.appraiseeuserid === item?.userid
      );

      if (!userKpis?.length) return acc;

      const latestKpi = userKpis.reduce((max, curr) =>
        curr.id > max.id ? curr : max
      );

      const isCompleted = latestKpi?.attendedon && latestKpi?.reviewedon;

      if (isCompleted) {
        acc.push({
          fullname: item?.fullname ?? "",
          hireddate: item?.hireddate
            ? dayjs(item?.hireddate)?.format("DD-MM-YYYY")
            : "",
          appraiseeuserid: item?.userid ?? "",
          appraiseruserid: item?.reportingmanager ?? "",
          basedepartmentid: item?.basedepartmentid ?? "",
          departmentname:
            departmentList?.find(
              (d) => d?.department_id === item?.basedepartmentid
            )?.department_name ?? "",
          title: "",
          type: "",
          attendstartdate: "",
          kpirole: [],
          templateid: "",
          templatename: "",
          kpistatus: "",
          appraiserintroductorysection: [],
          appraisermainquestionnairesection: [],
          appraiserremarkssection: [],
          attendedon: null,
          reviewedon: null,
        });
      }

      return acc;
    }, []);
    console.log("working124", reduceList);
    dispatch(setLoadNewList(reduceList));
    setLoadDataLoading(false);
  };

  console.log("findData-->", findData);

  const fetchData = async () => {
    setLoading(true);
    try {
      const { data, code } = await CALL_API(
        `performance/myteamappraisal/${userInfo?.userid}`,
        "get"
      );
      if (code === STATUS_CODE.SUCCESS) {
        setMyTeamData(Array.isArray(data) ? data : []);
        setLoading(false);
      } else {
        throw new Error(`Failed to fetch data: ${code}`);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const searchName = Form.useWatch("name", form);
  const filterDate = Form.useWatch("date", form);
  const filterType = Form.useWatch("type", form);

  // Add this filteredData derived from findData — replace dataSource={findData} with dataSource={filteredData}
  const filteredData = useMemo(() => {
    let result = [...(findData || [])];

    if (searchName) {
      result = result.filter((item) =>
        item?.fullname?.toLowerCase().includes(searchName.toLowerCase())
      );
    }

    if (filterDate) {
      result = result.filter((item) =>
        dayjs(item?.attendstartdate).isSame(dayjs(filterDate), "day")
      );
    }

    if (filterType?.length > 0) {
      result = result.filter((item) => {
        // "0" = Not Attended (no attendedon), "1" = Attended (has attendedon)
        if (filterType.includes("1") && filterType.includes("0")) return true;
        if (filterType.includes("1")) return !!item?.attendedon;
        if (filterType.includes("0")) return !item?.attendedon;
        return true;
      });
    }

    return result;
  }, [findData, searchName, filterDate, filterType]);

  const columns = [
    {
      title: "Name",
      dataIndex: "fullname",
      key: "fullname",
    },
    {
      title: "Employee ID",
      dataIndex: "appraiseeuserid",
      key: "appraiseeuserid",
      render: (text) => {
        return userList?.find((val) => val?.userid === text)?.employeeid;
      },
    },
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      render: (text) => {
        return text ? text : "-";
      },
    },
    // {
    //   title: "Issued KPI on",
    //   dataIndex: "createdat",
    //   key: "createdat",
    //   render: (text) => {
    //     return text ? dayjs(text).format("Do MMM YYYY") : "-";
    //   },
    // },
    {
      title: "Issued KPI on",
      dataIndex: "attendstartdate",
      key: "attendstartdate",
      render: (text) => {
        if (!text) return "-";

        const date = dayjs(text, "YYYY-MM-DD");

        if (!date.isValid()) return "-";

        const isSame = date.isSame(dayjs(), "day");

        return (
          <span className={isSame ? "text-danger" : ""}>
            {date.format("Do MMM YYYY")}
          </span>
        );
      },
    },
    {
      title: "Attend Appraisal from",
      dataIndex: "attendedon",
      key: "attendedon",
      render: (text) => {
        return text ? dayjs(text).format("Do MMM YYYY") : "-";
      },
    },
    {
      title: "Reviewed on",
      dataIndex: "reviewedon",
      key: "reviewedon",
      render: (text) => {
        return text ? dayjs(text, "DD-MM-YYYY").format("Do MMM YYYY") : "-";
      },
      //   className: "reason-column",
    },
    {
      key: "actions",
      width: 230,
      // fixed: "right",
      render: (status, record) => {
        const attendanceDate = dayjs(record?.attendstartdate) || "";
        const today = dayjs();

        const isPast = attendanceDate.isBefore(today, "day");
        const isAfterDate = attendanceDate.isAfter(today, "day");
        const isSameOrAfter = attendanceDate.isSame(today, "day");

        return (
          <>
            {!record.reviewedon && (
              <ActionWrapper>
                {!record.id &&
                  Menulist?.find(
                    (item) =>
                      item?.key === "myteamperformance" &&
                      item?.permission.create
                  ) && (
                    <p
                      style={{ cursor: "pointer", color: "#2d53da" }}
                      onClick={() =>
                        history.push("add-edit-kpi", { data: record })
                      }
                    >
                      + Add KPI
                    </p>
                  )}

                {record.id && (
                  <>
                    {/* Show Edit only for past dates */}
                    {record?.kpistatus === "0" && <>Draft</>}
                    {!record?.attendedon &&
                      Menulist?.find(
                        (item) =>
                          item?.key === "myteamperformance" &&
                          item?.permission.edit
                      ) && (
                        <EditOutlined
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            history.push("add-edit-kpi", { data: record })
                          }
                        />
                      )}

                    {/* Delete always visible */}
                    {Menulist?.find(
                      (item) =>
                        item?.key === "myteamperformance" &&
                        item?.permission.delete
                    ) && (
                      <DeleteOutlineOutlined
                        style={{ cursor: "pointer" }}
                        onClick={(e) => {
                          e.stopPropagation();
                          Modal.confirm({
                            title: "Are you sure you want to delete this KPI?",
                            icon: null,
                            centered: true,
                            okText: "Yes",
                            cancelText: "No",
                            okButtonProps: { type: "primary" },
                            onOk: () => handleDelete(record),
                          });
                        }}
                      />
                    )}

                    {/* Info only for past dates */}
                    {isAfterDate && record?.kpistatus === "1" && (
                      <Popover
                        content={
                          <>
                            Appraisees can attend the appraisal and you as
                            <br />
                            the appraiser can give your reviews right from
                            <br />
                            the appraisal date mentioned.
                          </>
                        }
                        arrow
                      >
                        <Info
                          sx={{
                            color: "#2D53DA",
                            fontSize: "20px",
                            marginRight: "8px",
                            cursor: "pointer",
                          }}
                        />
                      </Popover>
                    )}

                    {/* Show Review button for today + future */}
                    {isSameOrAfter &&
                      record?.kpistatus === "1" &&
                      Menulist?.find(
                        (item) =>
                          item?.key === "myteamperformance" &&
                          item?.permission.edit
                      ) && (
                        //
                        <p
                          style={{ cursor: "pointer", color: "#2d53da" }}
                          onClick={() =>
                            history.push("review", {
                              dataList: record,
                              isView: false,
                            })
                          }
                        >
                          Review the Appraisee
                        </p>
                      )}
                  </>
                )}
              </ActionWrapper>
            )}
          </>
        );
      },
    },
  ];

  const validateDateRange = () => {
    const endDate = dayjs(form.getFieldValue("end_date"));
    const startDate = dayjs(form.getFieldValue("start_date"));
    if (dayjs(startDate).isAfter(endDate)) {
      form.setFieldsValue({
        end_date: startDate,
      });
    }
  };

  const validateEndDateRange = () => {
    const startDate = dayjs(form.getFieldValue("start_date"));
    const endDate = dayjs(form.getFieldValue("end_date"));
    if (dayjs(endDate).isBefore(startDate)) {
      form.setFieldsValue({
        start_date: endDate,
      });
    }
  };

  useEffect(() => {
    if (!pageTitleRef.current) return;

    const baseOffset = 300;
    const minHeight = 120;

    const calculateScrollY = () => {
      const headerHeight = pageTitleRef.current.offsetHeight;

      const availableHeight = window.innerHeight - headerHeight - baseOffset;

      setScrollY(Math.max(minHeight, availableHeight));
    };

    calculateScrollY();

    const resizeObserver = new ResizeObserver(() => {
      calculateScrollY();
    });

    resizeObserver.observe(pageTitleRef.current);
    window.addEventListener("resize", calculateScrollY);

    return () => {
      resizeObserver.disconnect();
      window.removeEventListener("resize", calculateScrollY);
    };
  }, []);

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <MyTeamPerformanceWrap>
      <>
        <div className="page-title" ref={pageTitleRef}>
          <Form form={form} layout="vertical">
            <Row gutter={16}>
              <Col xs={24} sm={8} md={8} lg={4} ref={containerRef}>
                <Form.Item name="name">
                  <Input
                    placeholder="Search"
                    prefix={
                      <SearchOutlined
                        style={{ color: "#bfbfbf", width: "100%" }}
                      />
                    }
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={8} md={8} lg={4} ref={containerRef}>
                <Form.Item name="date">
                  <DatePicker
                    placeholder="Date"
                    format="DD-MM-YYYY"
                    className="w-100"
                    allowClear
                    getPopupContainer={() => containerRef.current}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={8} md={8} lg={4} ref={containerRef}>
                <Form.Item name="type">
                  <DropdownCheckBox
                    name="type"
                    label="Type"
                    options={[
                      { label: "Not Attended", value: "0" },
                      { label: "Attended", value: "1" },
                    ]}
                    className="input_field"
                    customStyle
                    form={form}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={8} md={24} lg={12} className="text-end mb-3">
                <Popover
                  content={
                    <>
                      This will generate a new list of appraisee whose
                      <br />
                      previous appraisals have been closed, allowing
                      <br />
                      you to create fresh performance KPIsfor them <br />
                      by retaining their previous Appraisals.
                    </>
                  }
                  arrow
                >
                  <ButtonFilled
                    type="primary"
                    style={{
                      width: "200px",
                      margin: 0,
                      borderRadius: "10px",
                    }}
                    loading={loadDataLoading}
                    onClick={loadNewData}
                  >
                    <User width={"20px"} className="mx-2" />
                    {""} Load New List
                  </ButtonFilled>
                </Popover>
              </Col>
            </Row>
          </Form>
        </div>
        <Spin spinning={loading}>
          <StyledTable
            columns={columns}
            dataSource={filteredData}
            pagination={false}
            scroll={{ y: scrollY }}
            style={{ minHeight: scrollY + 50 }}
            rowClassName={(_, index) => (index % 2 ? "non-white" : "")}
            onRow={(record) => ({
              onClick: (e) => {
                if (record?.reviewedon) {
                  history.push("/review", {
                    dataList: record,
                    isview: true,
                  });
                } else if (record?.id) {
                  e.stopPropagation();
                  setKpiDataList(record);
                  setIsViewKpi(true);
                }
              },
            })}
          />
        </Spin>
      </>
      <SuccessDeclinePopup
        open={popupOpen}
        setOpen={setPopupOpen}
        type="success"
        message="Deleted"
      />
    </MyTeamPerformanceWrap>
  );
};

export default MyTeamPerformance;
